import { useCallback } from "react";
import { useCurrentLocale } from "./useCurrentLocale";

export type I18nText = string | {
  default?: string;
} & Record<string, string>

export const useI18nText = () => {
  const currentLocale = useCurrentLocale();
  const translation = useCallback((text: I18nText) => {
    if (typeof text === "string") {
      return text;
    }
    if (text instanceof Object) {
      if (currentLocale in text) {
        return text[currentLocale];
      }
      return text.default ?? "";
    }
    return "";
  }, [currentLocale])
  
  return {
    translation,
  }
}